export default __webpack_public_path__ + "static/summer_containers29-fac58218a2465ce3dc1708e8a0a0ad7e.webp";